"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (tick1, tick2) {
    return !tick1 && tick1 === tick2 || !!tick1 && !!tick2 && tick1.epoch === tick2.epoch && tick1.quote === tick2.quote;
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/ticks/doTicksEqual.js
// module id = 28
// module chunks = 0